<div class="modal-header">
    <button type="button" class="close" aria-label="Close" (click)="cancel()"><span aria-hidden="true">&times;</span></button>
    <h4 class="modal-title" id="labelButtons">Change AZ MVD Now Email Address</h4>
</div>
<div class="modal-body">
    <validation-results [validationResults]="validationResults" *ngIf="showValidationComponent"></validation-results>
    <form [formGroup]="form">
        <fieldset>
            <div class="row">
                <div class="col-sm-6 mvd_form-group">
                    <label title="* Required" class="required" for="email">Email</label>
                    <input class="mvd_form-control" autocomplete="off" formControlName="email" maxlength="256" />
                    <control-validation-messages control="email"></control-validation-messages>
                </div>
            </div>
        </fieldset>
    </form>
</div>
<div class="modal-footer">
    <div class="btn--group">
        <button class="btn--default" type="button" [disabled]="inProgress" (click)="reset()">Reset</button>
        <button class="btn--default" type="button" [disabled]="inProgress" (click)="cancel()">Cancel</button>
        <button class="btn--primary" type="button" [disabled]="inProgress" (click)="searchEmail()">Save</button>
    </div>
</div>